import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-pre-admission',
   imports: [CommonModule, RouterModule],
  templateUrl: './pre-admission.component.html',
  styleUrl: './pre-admission.component.css',
})
export class PreAdmissionComponent {
    /* ── Form model ── */
  form = {
    parentName: '',
    email: '',
    phone: '',
    yearGroup: ''
  };
 
  formSubmitted = false;
  formError = false;
 
 pillars = [
  {
    num: '01',
    cls: 'al-pillar-1',
    title: 'Academic Mastery',
    body: 'Every question is mapped to the National Curriculum, giving a clear, topic-by-topic view of where your child stands against age-related expectations.',
    tag: 'Curriculum Aligned'
  },
  {
    num: '02',
    cls: 'al-pillar-2',
    title: 'Higher-Order Thinking',
    body: 'We assess reasoning, analysis, creativity, and decision-making — the thinking skills that drive performance beyond the classroom and into unfamiliar problems.',
    tag: 'Thinking-Focused'
  },
  {
    num: '03',
    cls: 'al-pillar-3',
    title: 'Growth & Confidence',
    body: 'A personalised learning plan with SMART targets and home learning recommendations, built to build confidence and momentum, not just flag gaps.',
    tag: 'Growth-Focused'
  }
];

structureCards = [
  {
    num: '01',
    cls: 'al-sc-maths',
    title: 'Mathematics Thinking Challenge',
    mark: 'Curriculum + Reasoning',
    topics: [
      'Conceptual understanding & problem solving',
      'Logical reasoning & pattern recognition',
      'Accuracy & time management'
    ]
  },
  {
    num: '02',
    cls: 'al-sc-english',
    title: 'English Thinking Challenge',
    mark: 'Curriculum + Reasoning',
    topics: [
      'Critical thinking & analytical reading',
      'Communication skills',
      'Independent learning & creativity'
    ]
  }
];

howSteps = [
  { num: '1', cls: 'al-step-1', title: 'Register', body: "Choose your child's year group and preferred assessment session." },
  { num: '2', cls: 'al-step-2', title: 'Assessment', body: 'Students complete an engaging, age-appropriate Mathematics and English Thinking Challenge.' },
  { num: '3', cls: 'al-step-3', title: 'Expert Evaluation', body: "Our experienced educators carefully analyse every aspect of your child's performance." },
  { num: '4', cls: 'al-step-4', title: 'Comprehensive Performance Report', body: 'Receive a detailed digital report highlighting strengths, development areas, thinking skills, and personalised recommendations.' },
  { num: '5', cls: 'al-step-5', title: 'Parent Consultation', body: 'Meet with our educators to understand the report and discuss tailored strategies for improvement.' },
  { num: '6', cls: 'al-step-6', title: 'Continuous Growth', body: 'Follow personalised learning targets and monitor progress as your child develops confidence, resilience, and academic excellence.' }
];

consultationChecklist = [
  'Overall Academic Performance',
  'Strengths and Achievements',
  'Learning Gaps',
  'Critical Thinking Skills',
  'Confidence and Learning Behaviours',
  'Personalised Learning Strategies',
  'Home Support Techniques',
  'Future Academic Goals'
];

receivesCards = [
  { icon: '📄', title: 'Comprehensive Digital Performance Report', body: 'A full breakdown of achievement, curriculum topics, and academic competency ratings.' },
  { icon: '🧩', title: 'Topic-by-Topic Curriculum Analysis', body: 'Exactly where your child stands, topic by topic, against age-related expectations.' },
  { icon: '🧠', title: 'Higher-Order Thinking Skills Profile', body: 'A clear picture of reasoning, analysis, creativity, and decision-making ability.' },
  { icon: '🎯', title: 'Personalised Learning Plan', body: 'SMART improvement targets and home learning recommendations built around your child.' },
  { icon: '📈', title: 'Next-Year Readiness Evaluation', body: 'An honest read on how prepared your child is for the year ahead.' },
  { icon: '🤝', title: 'Individual Parent Consultation', body: 'A one-to-one session with an educator to turn the report into an action plan.' }
];

faqs = [
  { open: false, q: 'Which year groups can take part?', a: 'The Thinking Challenge Assessment is available for every year group from Year 3 through to Year 11.' },
  { open: false, q: 'What does the assessment cover?', a: "A Mathematics and English Thinking Challenge that combines National Curriculum content with higher-order thinking skills like reasoning, analysis, and problem solving." },
  { open: false, q: 'How is this different from a normal school test?', a: 'Most tests measure what your child knows. Ours also measures how they think — reasoning, creativity, decision-making, and independent learning — alongside curriculum performance.' },
  { open: false, q: "What happens after my child's assessment?", a: 'Within 48 hours you receive a full digital performance report, followed by a one-to-one consultation with an experienced educator to walk through the results and next steps.' },
  { open: false, q: 'Is the parent consultation really included for free?', a: 'Yes — every registered family receives the assessment, the digital report, and the one-to-one consultation at no cost.' }
];
 
  ngOnInit() {
    /* Load Nunito font dynamically — Angular 7 pattern */
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800;900&display=swap';
    document.head.appendChild(link);
  }
 
  toggleFaq(index: number) {
    var self = this;
    self.faqs.forEach(function(faq, i) {
      if (i === index) {
        faq.open = !faq.open;
      } else {
        faq.open = false;
      }
    });
  }
 
  scrollToRegister() {
    var el = document.getElementById('al-register');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
 
  scrollToHowItWorks() {
    var el = document.getElementById('al-how-it-works');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
 
  onSubmit() {
    var self = this;
    if (!self.form.parentName || !self.form.email || !self.form.phone || !self.form.yearGroup) {
      self.formError = true;
      return;
    }
    self.formError = false;
    self.formSubmitted = true;
    /* TODO: wire to your API / ClassService here */
    console.log('Assessment registration:', self.form);
  }

}
